module.exports = __webpack_public_path__ + "img/广东美术馆“三馆合一”项目.62f1f681.png";